export default {
    NOMBRES: /^([a-zA-zñÑáéíóúÁÉÍÓÚ]+\s?)+$/
}